import { render, staticRenderFns } from "./deleteMallUser.vue?vue&type=template&id=136224ae"
import script from "./deleteMallUser.vue?vue&type=script&lang=js"
export * from "./deleteMallUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports